import { http } from '@pendo/http';

/**
 * @name meetsMinimumVersion
 * Used to check which app environments meet the provided minimum agent version.
 * @param {string} semver - "1.12.5"
 * @returns {object} - { "appId1": { "staging": true, "prodution": false } }
 */
export function meetsMinimumVersion (semver) {
    return http
        .get('/api/s/_SID_/environment/versioncheck', {
            params: {
                v: semver,
            },
        })
        .then((request) => request.data);
}
